import React from 'react'
import { withRouter } from 'react-router-dom'

const OldCMView = ({ history }) => {
  return (
    <div>
      Old CM view
    </div>
  )
}

export default withRouter(OldCMView)
